import { render, staticRenderFns } from "./OnlineSales.vue?vue&type=template&id=9ef39a2c&scoped=true"
import script from "./OnlineSales.vue?vue&type=script&lang=js"
export * from "./OnlineSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef39a2c",
  null
  
)

export default component.exports